import { getBrandingPartner } from './partners';

// What the PDF templates show wherever they would show hellohousing's logo (#2357): for an account
// created through a partner, or on a partner's plan, the partner's logo with "powered by
// hellohousing" (one image, see helpers/partners.js, getBrandingPartner); otherwise hellohousing's
// logo. A customer's own logo, where a template shows one, stays as it is.
export const getPdfDefaultLogo = (currentSubscription, hellohousingLogo, accountData = null) =>
  getBrandingPartner(accountData, currentSubscription)?.pdfLogo || hellohousingLogo;

// Width for drawing the logo element `height` pt high with jsPDF, in its own proportions: 75pt for
// hellohousing's logo (the width those templates always used), wider for a partner's.
export const getPdfLogoWidth = (logoElement, height = 38) =>
  logoElement?.naturalHeight ? Math.round((height * logoElement.naturalWidth) / logoElement.naturalHeight) : 75;
